import { AssetReference } from '@opallabs/cassini'
import {
  LinkWithData,
  Module,
  OnShowAssetPickerProps,
  ModuleDefinition,
  OnLinkDataUpdate,
} from '../Content/helpers/types'

export type GetModuleProps = {
  allProps: { [key: string]: string | LinkWithData[] }
  availableModules: ModuleDefinition[]
  assets: AssetReference[]
  content: string
  index: number
  module: Module
  modules: Module[]
  sectionPostOptions: { [key: string]: string }
  onShowAssetPicker: (args: OnShowAssetPickerProps) => void
  onRemoveAsset: (assetIndex: number, index: number) => void
  onExpandAsset: (assetIndex: number) => void
  updateCoverAsset: (
    assetData: FileList,
    assetId: number,
    index: number
  ) => void
  updateLinkData: OnLinkDataUpdate
  updateSectionOptions: (index: number, value: string, name: string) => void
}

export enum DRAG_STATES {
  DRAG = 'Drag to Reorder',
  PLACE = 'Release to Place',
}
